import type { App, Directive, DirectiveBinding } from 'vue'
import { useAppStore } from '@/store/modules/app'

// 檢查權限的邏輯
function hasPermi(el: Element) {
  const appStore = useAppStore()

  // 根據邏輯來檢查權限
  // const hasPermission = appStore.isDevelopment
  const hasPermission = false

  // 如果沒有權限，則移除元素
  if (!hasPermission) {
    el.remove()
  }

  return hasPermission
}

// 使用指令的 mounted 生命週期鉤子
const mounted = (el: Element, binding: DirectiveBinding) => {
  hasPermi(el) // 直接使用簡化過的邏輯
}

const permiDirective: Directive = {
  mounted
}

export const setupIsDevelopmentDirective = (app: App<Element>) => {
  app.directive('isDevelopment', permiDirective)
}

export default permiDirective
